/** Estados comerciales oficiales del ecosistema Javiland */
export const COMMERCIAL_STATES = [
  { id: 'exploracion', label: 'Exploración', color: '#607d8b' },
  { id: 'propuesta_enviada', label: 'Propuesta enviada', color: '#1565c0' },
  { id: 'en_alineacion', label: 'En alineación', color: '#ef6c00' },
  { id: 'en_ejecucion', label: 'En ejecución', color: '#2e7d32' },
  { id: 'entregado', label: 'Entregado', color: '#5d4037' },
  { id: 'en_pausa', label: 'En pausa', color: '#9e9e9e' }
];

export const stateLabel = (id) =>
  COMMERCIAL_STATES.find((s) => s.id === id)?.label || id;

export const stateColor = (id) =>
  COMMERCIAL_STATES.find((s) => s.id === id)?.color || '#666';

/** Clientes Growth Partner */
export const GROWTH_PARTNER_CLIENTS = [
  {
    id: 'strutech',
    name: 'Strutech Solutions',
    sector: 'Diseño y construcción · Bogotá',
    gpState: 'en_ejecucion',
    gpPhase: 'Fase 2 — 6 pilares + MVP comercial',
    doc: 'PLAN_MAESTRO_STRUTECH_2026.md',
    url: 'https://strutechsolutions.com/',
    notes: 'Cuota 1 COP 250k recibida. Demo jun 2026.'
  },
  {
    id: 'liliana',
    name: 'Liliana Ospina',
    sector: 'Bienestar · Conecta + GP',
    gpState: 'en_alineacion',
    gpPhase: 'Piloto referidos + cursos → GP',
    doc: 'PROMPT_JEFE_LILIANA_OSPINA_JAVILAND.md',
    alsoIn: 'Servicios / Bienestar',
    notes: 'M1 enviado. Call 2 pendiente. Alineación comercial en curso.'
  },
  {
    id: 'omar',
    name: 'Omar Londoño',
    sector: 'Tapires / Indi Stones',
    gpState: 'en_alineacion',
    gpPhase: '3 vías: viajes · tienda · GP indistones.co',
    doc: 'SUBPROYECTO_OMAR_JAVILAND.md',
    notes: 'M1 Instagram enviado. Conoce Colombia reactivado — sincronizar rutas Pinchake.'
  },
  {
    id: 'kaaba',
    name: 'Kaaba Café',
    sector: 'KAABA TRADING COLOMBIA S.A.S · Café Huila',
    gpState: 'en_alineacion',
    gpPhase: 'Canal tienda prioritario · F1 web (750k) en espera',
    doc: 'PROPUESTA_COMERCIAL_KAABA_CAFE_FEB2026.md',
    pdf: 'PROPUESTA_COMERCIAL_KAABA_CAFE_FEB2026.pdf',
    alsoIn: 'Canal tienda',
    notes: 'GP web F1 no aprobada. En alineación: precios/fichas café → SKU tienda.'
  },
  {
    id: 'jdn',
    name: 'JDN Life Style',
    sector: 'Moda · camisetas USA',
    gpState: 'en_alineacion',
    gpPhase: 'Canal tienda + GP digital',
    doc: 'PROPUESTA_COMERCIAL_JDN_LIFE_STYLE_MAYO_2026.md',
    url: 'https://www.instagram.com/jdnlifestyle2024/',
    notes: 'Alineación camisetas en tienda. Lista SKUs pendiente del dueño.'
  },
  {
    id: 'nutrisetas',
    name: 'Nutrisetas',
    sector: 'Setas y hongos · Shopify/Wix',
    gpState: 'en_alineacion',
    gpPhase: 'Colaboración informal (optimización Wix)',
    doc: null,
    url: 'https://www.nutrisetas.com/',
    notes: 'Acceso Wix. Catálogo completo → tienda Javiland.'
  },
  {
    id: 'rgs',
    name: 'RGS Marketing Experience',
    sector: 'Marketing BTL',
    gpState: 'entregado',
    gpPhase: 'Rediseño web + formulario leads',
    url: 'https://rgsbtl.com/',
    notes: 'Caso portfolio.'
  },
  {
    id: 'efecto-mariposa',
    name: 'Efecto Mariposa',
    sector: 'Educación y desarrollo personal',
    gpState: 'entregado',
    gpPhase: 'Páginas de cursos + optimización',
    url: 'https://efectomariposa.life/',
    notes: 'Caso portfolio.'
  }
];

/** Canal tienda / proveedores */
export const CANAL_TIENDA_ACTORS = [
  {
    id: 'kaaba',
    name: 'Kaaba Café',
    canalState: 'en_alineacion',
    priority: 'alta',
    blocker: 'Precios y fichas de producto (seguimiento WhatsApp)',
    followUp: true,
    followUpHint: 'Pedir precios y SKUs café Huila al cliente',
    nextStep: 'Crear SKU en Productos cuando lleguen datos',
    category: 'consumo-consciente',
    doc: 'PROPUESTA_COMERCIAL_KAABA_CAFE_FEB2026.md',
    whatsappTemplate:
      'Hola, equipo Kaaba. Desde Javiland avanzamos con la venta del café en nuestra tienda. ¿Nos pueden compartir precios, referencias y fichas (foto + descripción) de los productos Huila que quieren listar? Con eso armamos los SKU en javiland.com. Gracias.'
  },
  {
    id: 'himalaya',
    name: 'Himalaya (dropshipping)',
    canalState: 'en_ejecucion',
    priority: 'alta',
    blocker: null,
    doc: 'MATRIZ_PROVEEDORES_JAVILAND_2026.md',
    nextStep: 'Operación diaria cola dropshipping'
  },
  {
    id: 'annita',
    name: 'AnnitaMiel',
    canalState: 'en_alineacion',
    priority: 'media',
    blocker: 'Flete Medellín → Chía (Santiago)',
    doc: 'PROPUESTA_ANNITAMIEL_2026.md',
    nextStep: 'Reorden PET 750g tras flete'
  },
  {
    id: 'jdn',
    name: 'JDN Life Style',
    canalState: 'en_alineacion',
    priority: 'media',
    blocker: 'Lista camisetas (nombre, talla, precio, foto)',
    nextStep: 'Fase 1: SKUs actuales. Fase 2: import USA'
  },
  {
    id: 'nutrisetas',
    name: 'Nutrisetas',
    canalState: 'en_alineacion',
    priority: 'media',
    blocker: 'Alinear catálogo completo nutrisetas.com → Javiland',
    nextStep: 'Importar mismos productos a tienda'
  },
  {
    id: 'jdn-import',
    name: 'JDN import USA',
    canalState: 'exploracion',
    priority: 'baja',
    blocker: 'Inversión + marcas (Columbia, Quiksilver, etc.)',
    nextStep: 'Fase 2 tras validar camisetas actuales'
  }
];

export const GP_FILTER_OPTIONS = [
  { id: 'activos', label: 'Activos' },
  { id: 'en_alineacion', label: 'En alineación' },
  { id: 'en_ejecucion', label: 'En ejecución' },
  { id: 'entregados', label: 'Entregados' },
  { id: 'todos', label: 'Todos' }
];

const GP_STATE_SORT = {
  en_ejecucion: 0,
  en_alineacion: 1,
  propuesta_enviada: 2,
  exploracion: 3,
  en_pausa: 4,
  entregado: 5
};

export function sortGpClients(list) {
  return [...list].sort(
    (a, b) =>
      (GP_STATE_SORT[a.gpState] ?? 9) - (GP_STATE_SORT[b.gpState] ?? 9) ||
      String(a.name).localeCompare(String(b.name), 'es')
  );
}

export function filterGpClients(filterId) {
  let list = GROWTH_PARTNER_CLIENTS;
  if (filterId === 'entregados') {
    list = list.filter((c) => c.gpState === 'entregado');
  } else if (filterId === 'en_alineacion') {
    list = list.filter((c) => c.gpState === 'en_alineacion');
  } else if (filterId === 'en_ejecucion') {
    list = list.filter((c) => c.gpState === 'en_ejecucion');
  } else if (filterId === 'activos') {
    list = list.filter((c) =>
      ['propuesta_enviada', 'en_alineacion', 'en_ejecucion', 'exploracion'].includes(c.gpState)
    );
  }
  return sortGpClients(list);
}

/** Pasos operativos Kaaba — canal tienda */
export const KAABA_CANAL_CHECKLIST = [
  'Enviar WhatsApp pidiendo precios y fichas (referencias café Huila)',
  'Recibir fotos, descripciones y precio sugerido por SKU',
  'Crear productos en panel → categoría Consumo consciente',
  'Definir fulfillment (Javiland Chía vs proveedor) y publicar activos'
];

/** Comisión referidos canal Javiland — año 1 (Fase 4 GP escala año 2+) */
export const ECOSYSTEM_COMMISSION_YEAR1_PCT = 5;
export const ECOSYSTEM_COMMISSION_PHASE4_NOTE =
  'Fase 4 GP: revisión contractual año 2 hacia 10–15% según volumen';

/** Proveedores Conoce Colombia (turismo) */
export const CONOCE_COLOMBIA_PROVIDERS = [
  {
    id: 'aleja',
    name: 'Alejandra Puentes Sayo',
    shortName: 'Aleja',
    canalState: 'en_alineacion',
    priority: 'alta',
    specialty: 'Buceo · mar · Seaflower',
    channel: 'conoce-colombia',
    commissionYear1Pct: ECOSYSTEM_COMMISSION_YEAR1_PCT,
    commissionNotes: ECOSYSTEM_COMMISSION_PHASE4_NOTE,
    doc: 'CONOCE_COLOMBIA_ECOSISTEMA_2026.md',
    pdfProvidencia: 'PROPUESTA_EXPEDICION_PROVIDENCIA_ALEJA_AGO2026.pdf',
    pdfGorgona: 'PROPUESTA_DESTINO_GORGOVA_ALEJA_SEP2026.pdf',
    instagram: 'https://www.instagram.com/aleja.sayo/',
    whatsapp: '573218277761',
    activeExperiences: 2,
    nextStep: 'Sincronizar leads WhatsApp y registrar cierres para comisión 5%',
    followUp: true,
    followUpHint: 'Seguimiento amigo + trazabilidad referidos Aleja'
  },
  {
    id: 'tapires',
    name: 'Tapires Andinos (Pinchake)',
    operatorName: 'Omar Londoño',
    canalState: 'en_alineacion',
    priority: 'media',
    specialty: 'Ecopedagogía · alta montaña · Tolima',
    channel: 'conoce-colombia',
    rnt: '124193',
    commissionYear1Pct: ECOSYSTEM_COMMISSION_YEAR1_PCT,
    commissionNotes: ECOSYSTEM_COMMISSION_PHASE4_NOTE,
    doc: 'SUBPROYECTO_OMAR_JAVILAND.md',
    instagram: 'https://www.instagram.com/pinchake/',
    activeExperiences: 0,
    blocker: 'Sincronizar catálogo fechas/precios desde Pinchake',
    nextStep: 'Completar TAPIRES_EXPERIENCES en conoceColombia.js con Omar',
    followUp: true,
    followUpHint: 'Pedir matriz rutas + fechas 2026 (Instagram ya tiene calendario)'
  }
];

export const CONOCE_COLOMBIA_CHECKLIST = [
  'Deploy build con vitrina 3 secciones (Disponibles · Alianzas · Pipeline)',
  'Verificar WhatsApp Aleja desde tarjetas Providencia y Gorgona',
  'Omar: importar fechas/precios Pinchake → constantes Tapires',
  'Registrar primer lead referido para trazabilidad comisión 5%'
];
